<template>
  <div>
    <app-header><org-nav></org-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Ponto de Controlo {{ posto }}</h2>
      </div>
      <div v-if="horaInicio">
  			<p>Hora de Início: <strong>{{ horaInicio }}</strong></p>
  			<hr>
  			<div class="input-group col-md-3 col-xs-12">
  	      <input type="number" pattern="[0-9]*" v-model="dorsal" class="form-control" placeholder="dorsal..." @keyup.enter="regista" autofocus ref='inputDorsal'>
  	      <span class="input-group-btn">
  	        <button class="btn btn-success" type="button" @click="regista()" :disabled="!dorsal || dorsal <= 0">Regista</button>
            <button class="btn btn-danger" type="button" @click="anula()" >Anula</button>
  	      </span>
  	    </div>
  			<hr>
				<p>Já passaram: <strong>{{ chegadas.atletas.conta }}</strong> atletas</p>
				<hr>
  			<div class="table-responsive">
  				<table class="table table-striped tabela">
  					<thead>
  						<tr>
  							<th class="text-left">Dorsal</th>
  							<th class="text-right">Hora</th>
  						</tr>
  					</thead>
  					<tbody>
  						<tr v-for="chegada in chegadas.chegadas" :key="chegada.dorsal">
  							<td class="text-left">{{ chegada.dorsal }}</td>
  							<td class="text-right">{{ chegada.hora }}</td>
  						</tr>
  					</tbody>
  				</table>
  			</div>
  	  </div>
  		<div v-if="!horaInicio">
  			<p>A prova ainda não iniciou....</p>
  		</div>
  		<br>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import OrgNav from './Nav.vue'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'CpControlo1',
  components: {
    AppHeader,
    OrgNav
  },
  data () {
    return {
      horaInicio: '',
			chegadas: {
				chegadas: [],
				atletas: {
					conta : 0
				}
			},
			dorsal: '',
			posto: 2,
    }
  },
  methods: {
		getHoraPartida() {
			axios.get(process.env.WEB_API + 'getHoraPartida.php')
				.then(response => this.horaInicio = response.data.hora)
		},
		regista() {
			axios.post(process.env.WEB_API + 'setControlo.php', {posto: this.posto, dorsal: this.dorsal, hora: moment().format('HH:mm:ss')})
				.then(response => this.getUltimas())
			this.dorsal = ''
			this.$refs.inputDorsal.focus()
		},
    anula() {
			axios.post(process.env.WEB_API + 'deleteControlo.php', {posto: this.posto})
				.then(response => this.getUltimas())
			this.dorsal = ''
			this.$refs.inputDorsal.focus()
		},
		getUltimas() {
			axios.post(process.env.WEB_API + 'getUltimasControlo.php', {posto: this.posto})
				.then(response => this.chegadas = response.data)
		}
	},
	mounted() {
		this.getHoraPartida()
		this.getUltimas()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Controlo2.vue?b7615b86